import { AverageInterpolator } from "./AverageInterpolator";
import { BackgroundInterpolator } from "./BackgroundInterpolator";
import type { ColorInterpolator } from "./ColorInterpolator";
import type { ColorInterpolatorFactory } from "./ColorInterpolatorFactory";
import { IntegerInterpolator } from "./IntegerInterpolator";
import { InterpolationMethod } from "./InterpolationMethod";

/**
 * Base implementation of ColorInterpolatorFactory interface.
 */
export class BaseColorInterpolatorFactory implements ColorInterpolatorFactory {
  /**
   * @inheritDoc
   */
  create(method: InterpolationMethod): ColorInterpolator {
    switch (method) {
      case InterpolationMethod.AVERAGE:
        return new AverageInterpolator(2);
      case InterpolationMethod.AVERAGE_9:
        return new AverageInterpolator(3);
      case InterpolationMethod.AVERAGE_16:
        return new AverageInterpolator(4);
      case InterpolationMethod.BACKGROUND:
        return new BackgroundInterpolator();
      case InterpolationMethod.INTEGER:
        return new IntegerInterpolator();
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    throw new TypeError(`Unknown interpolation method: ${method}`);
  }
}
